export type AdminMemberMatchReport = {
  id: string;
  type: string;
  description: string;
  status: string;
  reviewNotes: string | null;
  actionTaken: string | null;
  reporterEmail: string | null;
  createdAt: string;
};

export type AdminMemberMatch = {
  id: string;
  otherUserId: string;
  otherFirstName: string;
  status: string;
  statusLabel: string;
  canViewChat: boolean;
  reports: AdminMemberMatchReport[];
  createdAt: string;
  updatedAt: string;
  connectedAt: string | null;
  disconnectedAt: string | null;
  disconnectedBy: string | null;
};

type ReportLinkInput = {
  id: string;
  reporterId: string;
  reporterEmail: string | null;
  type: string;
  description: string;
  status: string;
  reviewNotes: string | null;
  actionTaken: string | null;
  createdAt: string;
};

export function enrichMemberMatchesWithReports(
  matches: AdminMemberMatch[],
  reports: ReportLinkInput[],
): AdminMemberMatch[] {
  if (reports.length === 0) {
    return matches.map((match) => ({ ...match, reports: match.reports ?? [] }));
  }

  return matches.map((match) => {
    const existing = match.reports ?? [];
    if (existing.length > 0) {
      return { ...match, reports: existing };
    }

    const linkedReports = reports
      .filter((report) => report.reporterId === match.otherUserId)
      .map((report) => ({
        id: report.id,
        type: report.type,
        description: report.description,
        status: report.status,
        reviewNotes: report.reviewNotes,
        actionTaken: report.actionTaken ?? null,
        reporterEmail: report.reporterEmail,
        createdAt: report.createdAt,
      }))
      .sort((left, right) => new Date(right.createdAt).getTime() - new Date(left.createdAt).getTime());

    return { ...match, reports: linkedReports };
  });
}

export type AdminMatchChatMessage = {
  id: string;
  senderId: string;
  senderFirstName: string;
  content: string;
  createdAt: string;
  replyToId: string | null;
};
